import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineLogout,
  AiFillAlert,
} from "react-icons/ai";
import { PiNotebookBold, PiStudentFill } from "react-icons/pi";
import { BiNetworkChart } from "react-icons/bi";
import { BsFillBookmarkFill, BsCodeSlash } from "react-icons/bs";
import { CiShare1, CiLaptop } from "react-icons/ci";
import { Outlet } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { FaFileAlt, FaUser, FaUserFriends } from "react-icons/fa";
import { logoutAccess } from "../../../store/stateFunctions";
const { Sider, Content } = Layout;

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();

  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */ s>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={300}
        // style={{ height: "100vh" }}
      >
        <div style={{ height: "100%", overflowY: "auto" }}>
          <div className="logo text-center">
            <p className="text-white   mb-0 float-end fs-4">
              {/* <span className="sm-logo">DC</span> */}
              {/* <span className="lg-logo">My Profile</span> */}
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: () => setCollapsed(!collapsed),
                }
              )}
            </p>
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[""]}
            onClick={({ key }) => {
              if (key === "signout") {
              } else {
                navigate(key);
              }
            }}
            items={[
              {
                key: "",
                icon: <AiOutlineUser className="fs-4" />,
                label: "My Account",
              },

              {
                key: "Career",
                icon: <CiLaptop className="fs-4" />,
                label: "Career Opportunities",
                children: [
                  {
                    key: "myapplications",
                    icon: <PiNotebookBold className="fs-4" />,
                    label: "Internship Applications",
                  },
                  {
                    key: "myjobapplications",
                    icon: <PiNotebookBold className="fs-4" />,
                    label: "Job Applications",
                  },
                ],
              },
              // {
              //   key: "shareidea",
              //   icon: <CiShare1 className="fs-4" />,
              //   label: "Share Idea",
              // },
              {
                key: "bookmark",
                icon: <BsFillBookmarkFill className="fs-4" />,
                label: "Bookmarks",
              },
              {
                key: "mynetwork",
                icon: <BiNetworkChart className="fs-4" />,
                label: "My Network",
              },
              {
                key: "myenquiries",
                icon: <FaFileAlt className="fs-4" />,
                label: "My Enquiries",
              },

              // {
              //   key: "myeventenquiries",
              //   icon: <AiOutlineUser className="fs-4" />,
              //   label: "Event Registrations",
              // },
              // {
              //   key: "Become",
              //   icon: <FaUser className="fs-4" />,
              //   label: "Become Ambassador",
              //   children: [
              //     {
              //       key: "becomeambassador",
              //       icon: <BsCodeSlash className="fs-4" />,
              //       label: "Become Ambassador",
              //     },
              //     {
              //       key: "ambassadorentry",
              //       icon: <AiOutlineDashboard className="fs-4" />,
              //       label: "Ambassador Applications",
              //     },
              //   ],
              // },
              // {
              //   key: "becomeambassador",
              //   icon: <PiStudentFill className="fs-4" />,
              //   label: "Become Ambassador",
              // },
              // {
              //   key: "allambassador",
              //   icon: <FaUserFriends className="fs-4" />,
              //   label: "All Ambassadors",
              // },
              {
                key: "studentfeedback",
                icon: <AiOutlineDashboard className="fs-4" />,
                label: "Feedback",
              },
              // {
              //   key: "",
              //   icon: <AiOutlineUser className="fs-4" />,
              //   label: "About Us",
              // },
              {
                key: "faqs",
                icon: <AiFillAlert className="fs-4" />,
                label: "Yuvasarathi FAQ",
              },
            ]}
          />
        </div>
      </Sider>
      <Layout className="site-layout">
        <Content
          style={{
            // margin: "24px 16px",
            padding: 22,
            // minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default Sidebar;

// import React, { useState } from "react";
// import { Layout, Menu } from "antd";
// import { useNavigate } from "react-router-dom";
// import {
//   AiOutlineUser,
//   AiOutlineLogout,
//   AiOutlineDashboard,
// } from "react-icons/ai";

// const { Sider } = Layout;

// const Sidebar = ({ userType }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     // Handle logout logic here
//     // You can clear the user's session or perform other necessary tasks.
//   };

//   // Define menu items based on user type
//   const studentMenuItems = [
//     {
//       key: "profile",
//       icon: <AiOutlineUser className="fs-4" />,
//       label: "Profile (Student)",
//     },
//     {
//       key: "studentDashboard",
//       icon: <AiOutlineDashboard className="fs-4" />,
//       label: "Student Dashboard",
//     },
//     {
//       key: "studentLogout",
//       icon: <AiOutlineLogout className="fs-4" />,
//       label: "Logout",
//     },
//   ];

//   const industryMenuItems = [
//     {
//       key: "profile",
//       icon: <AiOutlineUser className="fs-4" />,
//       label: "Profile (Industry)",
//     },
//     {
//       key: "industryDashboard",
//       icon: <AiOutlineDashboard className="fs-4" />,
//       label: "Industry Dashboard",
//     },
//     {
//       key: "industryLogout",
//       icon: <AiOutlineLogout className="fs-4" />,
//       label: "Logout",
//     },
//   ];

//   const menuItems = userType === "student" ? studentMenuItems : industryMenuItems;

//   return (
//     <Sider trigger={null} collapsible collapsed={collapsed}>
//       {/* Your logo and other sidebar content */}
//       <Menu
//         theme="dark"
//         mode="inline"
//         defaultSelectedKeys={["profile"]}
//         onClick={({ key }) => {
//           if (key === "studentLogout" || key === "industryLogout") {
//             handleLogout();
//           } else {
//             navigate(key);
//           }
//         }}
//       >
//         {menuItems.map((item) => (
//           <Menu.Item key={item.key} icon={item.icon}>
//             {item.label}
//           </Menu.Item>
//         ))}
//       </Menu>
//     </Sider>
//   );
// };

// export default Sidebar;
